module.exports = __webpack_public_path__ + "img/takeaway_icon.39545131.jpg";